import React from "react";

const PlayScenarioContext = React.createContext();

export default PlayScenarioContext;
